/**
 * Public job URLs combine a readable title with the job ID required to fetch
 * a listing. Keep this shared by renderers and the server-side resolver so
 * links always resolve to the same canonical URL we generate.
 */
export function jobSlug(title: string): string {
  const slug = title
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || "job";
}

export function jobUrl(title: string, id: number | string): string {
  return `/job/${jobSlug(title)}-${id}`;
}
